import { createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "py-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h1", {
  class: "anchor fw-bolder mb-5",
  id: "card-blocking"
}, [
  /*#__PURE__*/_createVNode("a", { href: "#card-blocking" }),
  /*#__PURE__*/_createTextVNode(" Card Blocking ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createTextVNode(" Use "),
  /*#__PURE__*/_createVNode("code", null, ".overlay-block"),
  /*#__PURE__*/_createTextVNode(" class for blocking card element. ")
], -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createVNode("div", { class: "rounded border p-10" }, [
    /*#__PURE__*/_createVNode("div", { class: "row" }, [
      /*#__PURE__*/_createVNode("div", { class: "col-lg-6" }, [
        /*#__PURE__*/_createVNode("div", { class: "card card-border overlay overlay-block" }, [
          /*#__PURE__*/_createVNode("div", { class: "card-header" }, [
            /*#__PURE__*/_createVNode("h3", { class: "card-title" }, "Card Blocking")
          ]),
          /*#__PURE__*/_createVNode("div", { class: "card-body" }, [
            /*#__PURE__*/_createVNode("div", { class: "overlay-wrapper p-5" }, " Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to. "),
            /*#__PURE__*/_createVNode("div", { class: "overlay-layer rounded bg-dark bg-opacity-5" }, [
              /*#__PURE__*/_createVNode("div", {
                class: "spinner-border text-primary",
                role: "status"
              }, [
                /*#__PURE__*/_createVNode("span", { class: "visually-hidden" }, "Loading...")
              ])
            ])
          ])
        ])
      ])
    ])
  ])
], -1)
const _hoisted_5 = { class: "py-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _createVNode("div", _hoisted_5, [
      _createVNode(_component_CodeHighlighter, { lang: "html" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(`
        <div class="card card-border overlay overlay-block">
          <div class="card-header">
            <h3 class="card-title">Card Blocking</h3>
          </div>
          <div class="card-body">
            <div class="overlay-wrapper p-5">
              Lorem Ipsum is simply dummy text....
            </div>
            <div class="overlay-layer rounded bg-dark bg-opacity-5">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
          </div>
        </div>
        `), 1)
        ]),
        _: 1
      })
    ])
  ]))
}